import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Tab,
  Tabs,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
import Typography from "../../typography/typography";
import Button from "../../button/button";
import Modal from "../../modal/modal";
import "./shared-page-modal.scss";
import { useEffect, useState } from "react";
import SearchBar from "../../search-bar/search-bar";
import Toggle from "../../toggle/toggle";
import SharedPageView from "./shared-page-view";
import { useDispatch } from "react-redux";
import { setSharedPage } from "../../../views/afterAuth/dashboard/redux/reducer";

interface IAddPage {
  open: boolean;
  onClose: () => void;
  pages?: any;
  handleSubmit: (page: any) => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="shared-tab"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const SharedPageModal = ({ open, onClose, pages, handleSubmit }: IAddPage) => {
  const [value, setValue] = useState(0);
  const [sharedPages, setSharedPages] = useState(pages);
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSharedPage(sharedPages));
  }, [dispatch, sharedPages]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleSave = () => {
    handleSubmit(pages[value]);
  };

  const renderTabs = () => {
    const filteredPages = sharedPages.filter((page: any) =>
      page.name.toLowerCase().includes(searchQuery.toLowerCase()),
    );

    return filteredPages.map((page: any, index: number) => (
      <Tab key={index} label={page.name} {...a11yProps(index)} />
    ));
  };

  const PageDescription = ({ page }: { page: any }) => {
    let viewsMessage = "",
      filtersMessage = "";

    if (page?.details?.views?.length === 1) {
      viewsMessage = `This page has 1 view, you can customize it`;
    } else if (page?.details?.views?.length) {
      viewsMessage = `This page has ${page?.details?.views?.length} different views, you can customize them`;
    } else {
      viewsMessage = `In this page you can add different views and customize them`;
    }

    if (page?.details?.filters?.length === 1) {
      filtersMessage = `, and it also have a saved filters to make things easier for you.`;
    } else if (page?.details?.filters?.length) {
      filtersMessage = `, and there are also ${page?.details?.filters?.length} saved filters to make things easier for you.`;
    } else {
      filtersMessage = `, and you can also add filters to make things easier for you`;
    }

    return <p>{viewsMessage + filtersMessage}</p>;
  };

  const handleToggle = () => {
    setSharedPages((prevPages: any) => {
      const updatedPages = prevPages.map((page: any, index: any) => {
        if (index === value) {
          return {
            ...page,
            isPinToDashboard: !page.isPinToDashboard,
          };
        }
        return page;
      });
      return updatedPages;
    });
  };

  const handleSharedView = (viewStyle: number) => {
    setSharedPages((prevPages: any) => {
      const updatedPages = prevPages.map((page: any, index: any) => {
        if (index === value) {
          return {
            ...page,
            viewStyle: viewStyle,
          };
        }
        return page;
      });
      return updatedPages;
    });
  };

  const handleSearchBar = (value: string) => {
    setSearchQuery(value);
    setValue(0);
  };
  return (
    <>
      <Modal
        fullWidth
        onClose={onClose}
        open={open}
        className="shared-pages-modal"
      >
        <DialogTitle>
          <Typography type="s3" weight="medium" color={"theme.secondary.1000"}>
            Shared Views
          </Typography>
          <IconButton edge="end" onClick={onClose} size="small">
            <Close fontSize="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            {sharedPages?.length ?
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={4} className="tab-title-wrap">
                  <div className="tab-search-wrap">
                    <SearchBar
                      placeholder={"Search User"}
                      handleSearch={handleSearchBar}
                    />
                  </div>
                  <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: "divider" }}
                  >
                    {renderTabs()}
                  </Tabs>
                </Grid>
                <Grid className="shared-grid-wrap" item xs={8}>
                  {sharedPages
                    .filter((page: any) =>
                      page.name.toLowerCase().includes(searchQuery.toLowerCase()),
                    )
                    .map((page: any, index: number) => (
                      <TabPanel value={value} index={index} key={index}>
                        <div className="shared-pages-main">
                          <SharedPageView
                            pageValue={index}
                            pages={sharedPages}
                            onChange={handleSharedView}
                          />
                        </div>
                        <div className="tab-info-wrap">
                          <div className="tab-inner-info">
                            <div>
                              <h1>{page.name}</h1>
                            </div>
                            <div className="tab-toggle">
                              <div>
                                <FormControlLabel
                                  control={
                                    <Toggle
                                      checked={page.isPinToDashboard}
                                      onChange={handleToggle}
                                    />
                                  }
                                  label="Pined to dashboard"
                                  labelPlacement="start"
                                />
                              </div>
                              <div className="owner-name-wrap">
                                <p>
                                  <span>Owner:</span> {page.owner}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="tab-content">
                            <PageDescription page={page} />
                          </div>
                        </div>
                      </TabPanel>
                    ))}
                </Grid>
              </Grid>
            </Box>
             : <Box display='flex' width='100%' height='100%' alignItems='center' justifyContent='center'><Typography type="s1" color='theme.secondary.800'>No Views has been shared with you</Typography></Box>}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={onClose}
            style={{
              color: "black",
            }}
            disabled={!sharedPages?.length}
          >
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={!sharedPages?.length}>Duplicate</Button>
        </DialogActions>
      </Modal>
    </>
  );
};

export { SharedPageModal };
export default SharedPageModal;
